import React from "react";
import View from "../../pages/createTeam";
import imageCompression from "browser-image-compression";
import { Box } from "@material-ui/core";
import { Loading } from "../../ui/loader";

class CreateTeam extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      eventId: null,
      name: "",
      src: null,
    };
  }

  componentDidMount() {
    this.props.getComingEvents();
    this.props.getCarValues();
    this.props.getRacingBracket();
  }

  onTeamChange = (e) => {
    this.setState({ eventId: e.target.value });
    if (e.target.value === "...") {
      this.setState({ eventId: null });
    } else {
      this.props.getBusyCarNumber(e.target.value);
    }
  };
  onCreateTeam = (car_info, team_info) => {
    this.props.createNewTeam(car_info, team_info).then((team) => {
      if (team) {
        this.props.history.push("/teams");
      }
    });
  };

  onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      let options = {
        maxSizeMB: 0.5,
        maxWidthOrHeight: 192,
        useWebWorker: true,
      };
      this.setState({ name: event.target.value.split(/(\\|\/)/g).pop() });
      imageCompression(event.target.files[0], options).then(
        (compressedFile) => {
          let reader = new FileReader();
          reader.onload = (e) => {
            this.setState({ src: reader.result });
          };
          reader.readAsDataURL(compressedFile);
        }
      );
    } else {
      this.setState({ src: "", name: "" });
    }
  };

  render() {
    const { events, number, carValues, racingBracket } = this.props;
    const { eventId, src } = this.state;
    if (events.loading) {
      return <Loading loading={events.loading} />;
    }
    return (
      <Box
        borderRight="1px solid #DCDCDC"
        borderBottom="1px solid #DCDCDC"
        className="rightMemberAreaScreen"
      >
        <View
          handleTeamChange={this.onTeamChange}
          handleImageChange={this.onImageChange}
          handleCreateTeam={this.onCreateTeam}
          events={events.events}
          eventId={eventId}
          image={src}
          number={number.number}
          carValues={carValues.carValues}
          racingBracket={racingBracket.racingBracket}
        />
      </Box>
    );
  }
}

export default CreateTeam;
